import React, {type PropsWithChildren} from 'react';
import type {SuggestionProps} from '@tiptap/suggestion';

import classNames from 'classnames';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import {sendToStatist} from '@time-webkit/statist';

import HashTagIcon from 'components/widgets/icons/hash_tag_icon';

import {MentionList} from 'packages/editor/src/components/mention-list';
import {type IEditor} from 'packages/editor';

import styles from './styles.module.css';

type MentionListProps = {
    getMentions: (query: string) => Promise<string[]>;
    editor?: IEditor;
} & Pick<SuggestionProps<string>, 'query' | 'command' | 'decorationNode'>;

const Handle: React.FC<PropsWithChildren> = (props) => {
    const typographyCls = useTypography({
        size: TypographySize.BodyL,
    });

    return <span className={classNames(styles.handle, typographyCls)}>{props.children}</span>;
};

const HashtagOption = ({hashtag}: {hashtag: string}) => {
    return (
        <div className={styles.mentionWrapper} role='option'>
            <span className={classNames(styles.icon, styles.groupIcon)}>
                <HashTagIcon size={16} />
            </span>
            <Handle>{hashtag.slice(1)}</Handle>
        </div>
    );
};

export const HashtagMentionList: React.FC<MentionListProps> = (props) => {
    const {query, getMentions, command, decorationNode} = props;
    const onSelect = (_: {handle: string}, index: number) => {
        sendToStatist('editor.searchHashtag.resultTap', {
            resultNumber: index + 1,
        });
    };
    const onGetMentions = async (query: string) => {
        const mentions = await getMentions(query);
        return mentions.map((m) => ({handle: m}));
    };

    return (
        <MentionList
            query={query}
            command={(mention) => command(mention.handle)}
            decorationNode={decorationNode}
            getMentions={onGetMentions}
            renderMentionOption={(item) => <HashtagOption hashtag={item.handle} />}
            onSelect={onSelect}
            editor={props.editor}
        />
    );
};
